import React from "react";
import Project1 from "./../../assets/images/buildings/Picture1.jpg";
import Project2 from "./../../assets/images/buildings/Picture2.jpg";
import Project3 from "./../../assets/images/buildings/Picture3.jpg";
import Project4 from "./../../assets/images/buildings/Picture4.jpg";
import Project5 from "./../../assets/images/buildings/Picture5.jpg";
import Project6 from "./../../assets/images/buildings/Picture6.jpg";
import Project7 from "./../../assets/images/buildings/Picture7.jpg";
import Project8 from "./../../assets/images/buildings/Picture8.jpg";
import Project9 from "./../../assets/images/buildings/Picture9.jpg";
import Project10 from "./../../assets/images/buildings/Picture10.jpg";
import Project11 from "./../../assets/images/buildings/Picture11.jpg";
import Project12 from "./../../assets/images/buildings/Picture12.jpg";
import Project13 from "./../../assets/images/buildings/Picture13.jpg";
import Project14 from "./../../assets/images/buildings/Picture14.jpg";
import Project15 from "./../../assets/images/buildings/Picture15.jpg";
import Project16 from "./../../assets/images/buildings/Picture16.jpg";
import Project17 from "./../../assets/images/buildings/Picture17.jpg";
import Project18 from "./../../assets/images/buildings/Picture18.jpg";
import Project19 from "./../../assets/images/buildings/Picture19.jpg";
import Project20 from "./../../assets/images/buildings/Picture20.jpg";
// import Project21 from "./../../assets/images/buildings/Picture21.jpg";
// import Project22 from "./../../assets/images/buildings/Picture22.jpg";
import Project23 from "./../../assets/images/buildings/Picture23.jpg";
import Project24 from "./../../assets/images/buildings/Picture24.jpg";
import Project25 from "./../../assets/images/buildings/Picture25.jpg";
import "./Projects.scss";

const Projects = () => {
  return (
    <div className="Projects_Page">
      <div className="Gallery_Container">
        <div className="wide5tall2">
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src={Project1} alt="Avatar" />
              </div>
              <div class="flip-card-back">
                <h1>International Cruz Terminals</h1>
                {/* <p>Architect & Engineer</p> */}
                {/* <p>ICT</p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="tall4">
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src={Project4} alt="Avatar" />
              </div>
              <div class="flip-card-back">
                <h1>Kolekayan</h1>
                {/* <p>Architect & Engineer</p>
                <p>We love that guy</p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="wide2tall3">
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src={Project20} alt="Avatar" />
              </div>
              <div class="flip-card-back">
                <h1>20</h1>
                {/* <p>Architect & Engineer</p>
                <p>We love that guy</p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="tall3">
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src={Project3} alt="Avatar" />
              </div>
              <div class="flip-card-back">
                <h1>Magestic Villa</h1>
                {/* <p>Architect & Engineer</p>
                <p>We love that guy</p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="big3">
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src={Project24} alt="Avatar" />
              </div>
              <div class="flip-card-back">
                <h1>24</h1>
                {/* <p>Architect & Engineer</p>
                <p>We love that guy</p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="big">
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src={Project25} alt="Avatar" />
              </div>
              <div class="flip-card-back">
                <h1>25</h1>
                {/* <p>Architect & Engineer</p>
                <p>We love that guy</p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="big">
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src={Project19} alt="Avatar" />
              </div>
              <div class="flip-card-back">
                <h1>19</h1>
                {/* <p>Architect & Engineer</p>
                <p>We love that guy</p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="tall3">
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src={Project5} alt="Avatar" />
              </div>
              <div class="flip-card-back">
                <h1>Shree Samarth Heights</h1>
                {/* <p>Architect & Engineer</p>
                <p>We love that guy</p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="big">
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src={Project7} alt="Avatar" />
              </div>
              <div class="flip-card-back">
                <h1>7</h1>
                {/* <p>Architect & Engineer</p>
                <p>We love that guy</p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="big">
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src={Project23} alt="Avatar" />
              </div>
              <div class="flip-card-back">
                <h1>Muktistar</h1>
                {/* <p>Architect & Engineer</p>
                <p>We love that guy</p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="big">
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src={Project9} alt="Avatar" />
              </div>
              <div class="flip-card-back">
                <h1>9</h1>
                {/* <p>Architect & Engineer</p>
                <p>We love that guy</p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="tall">
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src={Project2} alt="Avatar" />
              </div>
              <div class="flip-card-back">
                <h1>Grand Arena</h1>
                {/* <p>Architect & Engineer</p>
                <p>We love that guy</p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="tall">
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src={Project6} alt="Avatar" />
              </div>
              <div class="flip-card-back">
                <h1>6</h1>
                {/* <p>Architect & Engineer</p>
                <p>We love that guy</p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="tall">
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src={Project8} alt="Avatar" />
              </div>
              <div class="flip-card-back">
                <h1>8</h1>
                {/* <p>Architect & Engineer</p>
                <p>We love that guy</p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="tall">
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src={Project10} alt="Avatar" />
              </div>
              <div class="flip-card-back">
                <h1>10</h1>
                {/* <p>Architect & Engineer</p>
                <p>We love that guy</p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="tall">
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src={Project11} alt="Avatar" />
              </div>
              <div class="flip-card-back">
                <h1>11</h1>
                {/* <p>Architect & Engineer</p>
                <p>We love that guy</p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="tall">
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src={Project12} alt="Avatar" />
              </div>
              <div class="flip-card-back">
                <h1>Madhukar Deshmukh Tower</h1>
                {/* <p>Architect & Engineer</p>
                <p>We love that guy</p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="tall">
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src={Project13} alt="Avatar" />
              </div>
              <div class="flip-card-back">
                <h1>13</h1>
                {/* <p>Architect & Engineer</p>
                <p>We love that guy</p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="tall">
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src={Project14} alt="Avatar" />
              </div>
              <div class="flip-card-back">
                <h1>shradha Vardaan</h1>
                {/* <p>Architect & Engineer</p>
                <p>We love that guy</p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="tall">
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src={Project15} alt="Avatar" />
              </div>
              <div class="flip-card-back">
                <h1>15</h1>
                {/* <p>Architect & Engineer</p>
                <p>We love that guy</p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="tall">
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src={Project16} alt="Avatar" />
              </div>
              <div class="flip-card-back">
                <h1>16</h1>
                {/* <p>Architect & Engineer</p>
                <p>We love that guy</p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="big">
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src={Project17} alt="Avatar" />
              </div>
              <div class="flip-card-back">
                <h1>17</h1>
                {/* <p>Architect & Engineer</p>
                <p>We love that guy</p> */}
              </div>
            </div>
          </div>
        </div>
        <div className="tall">
          <div class="flip-card">
            <div class="flip-card-inner">
              <div class="flip-card-front">
                <img src={Project18} alt="Avatar" />
              </div>
              <div class="flip-card-back">
                <h1>Shanti Sharan Heights</h1>
                {/* <p>Architect & Engineer</p>
                <p>We love that guy</p> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
